/**
 * Time unit associated with the nearby settlement day.
 * tag: 41267
 * @readonly
 * @enum {string} (String)
 */
export enum StreamCommodityNearbySettlDayUnit {
  /** Week */
  Week = 'Wk',
  /** Month */
  Month = 'Mo',
}
